import styled from 'styled-components';
import DocumentsAccordion from './DocumentsAccordion';
import { colorSchema, media } from 'utils/style';

export default styled(DocumentsAccordion)`
  .documents-accordion {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.4rem;

    &__header {
      align-items: center;
      background: ${colorSchema('grey100')};
      cursor: pointer;
      height: 65px;
      display: flex;
      justify-content: space-between;
      border: 0;
      margin-bottom: 1.6rem;
      padding: 1.6rem;
      width: 100%;

      ${media.greaterThan('tablet')`
        margin-bottom: 0;
      `}
    }

    &__header-name {
      align-items: center;
      display: flex;
      width: 33%;
    }

    &__header-title {
      color: ${colorSchema('grey700')};
      font-weight: 500;
      text-transform: uppercase;
    }

    &__container {
      margin-bottom: 2.4rem;
      ${media.greaterThan('tablet')`
        border-bottom: 1px solid ${colorSchema('grey300')};
      `}
    }

    &__label {
      display: flex;
      justify-content: flex-end;
      width: 33%;
    }

    &__label-text {
      color: ${colorSchema('primary500')};
      font-size: 1.4rem;
      font-weight: bold;
      margin-right: 0.8rem;
    }

    &__label-icon {
      transform: rotate(90deg);
      svg {
        fill: ${colorSchema('primary500')};
      }

      &--open {
        transform: rotate(-90deg);
      }
    }

    &__vehicle-icon {
      display: none;
      ${media.greaterThan('tablet')`
        display: block;
        margin-right: 1.6rem;
        svg {
          fill: ${colorSchema('grey500')};
        }
      `}
    }

    &__sublist {
      margin-bottom: 2.4rem;
      ${media.greaterThan('tablet')`
        border-bottom: 1px solid ${colorSchema('grey300')};
        margin-bottom: 4rem;
      `}
    }

    &__list-label {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
      font-weight: bold;
      margin: 0 0 0.8rem;
      text-transform: uppercase;
      ${media.greaterThan('tablet')`
        display: flex;
        align-items: center;
        margin: 0;
      `}
    }

    &__sublist-columns {
      display: none;
      justify-content: flex-end;
      margin-bottom: 0.4rem;
      ${media.greaterThan('tablet')`
        display: flex;
      `}
    }

    &__column {
      color: ${colorSchema('grey700')};

      font-size: 1.4rem;

      &--state {
        margin-right: 44.7rem;
      }

      &--expire {
        margin-right: 6.2rem;
      }
    }

    &__loading,
    &__error {
      display: flex;
      justify-content: center;
    }

    &__loading {
      color: ${colorSchema('primary500')};
      margin: 0;
      font-size: 1.6rem;
      animation: rotate 1s infinite linear;
    }

    &__sublist-columns {
      display: none;
      justify-content: flex-end;
      margin: 0.8rem 0;
      ${media.greaterThan('tablet')`
        display: flex;
      `}
    }

    &__entity {
      margin-bottom: 3.2rem;

      ${media.greaterThan('tablet')`
        margin-bottom: 4rem;
      `}
    }

    &__column {
      color: ${colorSchema('grey700')};

      font-size: 1.4rem;

      &--state {
        margin-right: 44.7rem;
      }

      &--expire {
        margin-right: 6.2rem;
      }
    }

    &__status-container {
      text-align: center;
      width: 33%;
    }

    &__status {
      display: none;
      text-transform: uppercase;
      font-size: 1.4rem;
      font-weight: 500;
      border-radius: 2px;
      padding: 0.4rem;

      ${media.greaterThan('tablet')`
        display: inline-block;
      `}

      &--completed {
        color: ${colorSchema('success900')};
        background-color: ${colorSchema('success100')};
      }

      &--pending {
        color: ${colorSchema('accent900')};
        background-color: ${colorSchema('accent100')};
      }
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
